import React from "react";
import styles from "./NewConnectionProfile.module.css";
import { toPersian } from "../../Utility/Utilities";
import PriceText from "../BuyTrafficModal/PriceText.module";
const EachPackage = ({
  pkg,
  onChange,
  isActive,
  setSelectedId,
  formatPrice,
  setSteps,
}) => {
  const handleSelect = (pkg) => {
    setSelectedId(pkg.id);
    onChange?.(pkg);
    setSteps(2);
  };

  return (
    <button
      key={pkg.id}
      onClick={() => handleSelect(pkg)}
      className={`${styles.butndi} ${isActive && styles.active}`}
      aria-pressed={isActive}
    >
      <div className={styles.eachPackage}>
        <div className={styles.firstR}>
          <div className={styles.pci}>
            {pkg.packageType == "Wireguard" && (
              <img width="40" src="/asets/Wiregaurd.svg" />
            )}
            {(pkg.packageType == "Ovpn" || pkg.packageType == "Ovpns") && (
              <img width="40" src="/asets/Ovpn.svg" />
            )}
          </div>
          <div>
            <div className={styles.profileName}>پروفایل {pkg.name}</div>
            <div className={styles.packType}>
              {pkg.packageType == "Ovpn" ? "OpenVpn" : "Wireguard"}
            </div>
            <div className={styles.gigPart}>
              <div className={styles.gigShow}>حجم ترافیک</div>
              <div className={styles.gigCount}>{pkg.traffic} GB</div>
            </div>
          </div>
        </div>
        <div className={styles.feutures}>
          {pkg.features?.map((f, i) => (
            <div className={styles.eachF} key={i}>
              {f == "تک کاربره" && <i className="fa-solid fa-user"></i>}
              {f == "دو کاربره" && (
                <i className="fa-solid fa-user-group-simple"></i>
              )}
              {f}
            </div>
          ))}
          <div className={styles.eachF}>
            <i class="fa-solid fa-calendar-days"></i>
            {toPersian(pkg.days)} روزه
          </div>
        </div>
        <div className={styles.sepLittle}></div>
        <div className={styles.pricingPart}>
          <PriceText value={pkg.price} />
        </div>
      </div>
      <div className={`${styles.choosing} ${isActive && styles.nowActive}`}>
        {isActive ? "انتخاب شده" : "انتخاب"}
      </div>
    </button>
  );
};
export default EachPackage;
